import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetResultVersion = (periodId, versionId) => {
  const query = useApiQuery(
    ['courseAssignmentResultVersion', periodId, versionId],
    'schools',
    client => client.get(`/current-organization/course-assignment/periods/${periodId}/results/${versionId}`),
    { enabled: !!periodId && !!versionId },
    { authenticated: true, version: 5 }
  )

  return {
    isLoading: query.isLoading,
    version: query.data ?? null,
    error: query.error
  }
}
